import React from 'react';
import Testimonial from '../Testimonial/Testimonial';

const SectionTestimonial = () => {
	return (
		<section className="section">
			<div className="wrapper">
				<Testimonial/>
			</div>
		</section>
	);
};

export default SectionTestimonial;



// WEBPACK FOOTER //
// ./src/components/SectionTestimonial/SectionTestimonial.js